import { render, staticRenderFns } from "./common-preview-image.vue?vue&type=template&id=b1556a8a&scoped=true&"
import script from "./common-preview-image.vue?vue&type=script&lang=js&"
export * from "./common-preview-image.vue?vue&type=script&lang=js&"
import style0 from "./common-preview-image.vue?vue&type=style&index=0&id=b1556a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1556a8a",
  null
  
)

export default component.exports